export const handleLogout = () => {
  sessionStorage.clear();
  window.location.href = "/";
};

export const idealTimer = 30 * 60 * 1000;
